import { validators } from '../pages/UploadPage/validators';

export function validateRules(rules, value) {
  try {
    return rules.every((rule) => validators[rule](value));
  } catch (e) {
    console.warn(e, value, 'err');
    return false;
  }
}
